export const registrationKeys = {
  all: ['registration'] as const,
  intent: (esid?: string, it?: string) =>
    [...registrationKeys.all, 'intent', esid, it] as const,
};
